import { useFormContext, useFormState } from 'react-hook-form'
import { useFormDisable } from './form'
import { useMemo } from 'react'

export const FormNewButtonSubmit = ({ text }) => {
  const { formState } = useFormContext()
  const { isValid, isDirty } = useFormState()

  const formDisabled = useFormDisable()

  const disabled = useMemo(
    () => {
      if (formDisabled) {
        return true
      }

      if (!isValid) {
        return true
      }

      if (!isDirty) {
        return true
      }

      if (Object.keys(formState.errors).length) {
        return true
      }

      return false
    },
    [formDisabled, isValid, isDirty, formState]
  )

  return (
    <button className="btn btn-primary me-1  mt-1" type="submit" disabled={disabled}>
      {text || 'Submit'}
    </button>
  )
}
